import axios from '../../../../api/config'
import i18n from '../../../../i18n'
import {
  getGlossariesAPI,
  getBooksByGlossaryAPI,
  getLessonsByBookAPI,
  getInitialSequenceAndBlockSizeAPI,
  checkIfForceReviewAPI
} from '../../../../api/vocabularyAPI'

const state = {
  waitForFetching: false,
  glossaryList: [],
  bookList: [],
  lessonList: [],
  chosenGlossary: null,
  chosenBook: null,
  chosenLesson: null,
  initSeq: 0,
  maxSeqOfGlossary: 0,
  upgradedUserForceReviewWordList: [],
  notLearnedYet: '',
  learningCompleted: false
}

const getters = {}

const mutations = {
  setWaitForFetching (state, status) {
    state.waitForFetching = status
  },
  setGlossaryList (state, payload) {
    payload = [{
      text: i18n.t('Vocabulary.selectGlossary'),
      value: null
    }, ...payload]
    state.glossaryList = payload
  },
  setBookList (state, payload) {
    state.bookList = [{
      text: i18n.t('Vocabulary.selectBook'),
      value: null
    }, ...payload]
  },
  setLessonList (state, payload) {
    state.lessonList = [{
      text: i18n.t('Vocabulary.selectLesson'),
      value: null
    }, ...payload]
  },
  setChosenGlossary (state, payload) {
    state.chosenGlossary = payload.glossary
  },
  setChosenGlossaryInfo (state, payload) {
    state.chosenGlossary = payload.glossary
    state.chosenBook = payload.book
    state.chosenLesson = payload.lesson
  },
  setOtherFields (state, payload) {
    state.initSeq = payload.beginFrom
    state.maxSeqOfGlossary = payload.maxSeqOfGlossary
  },
  setUpgradedUserForceReviewWordList (state, payload) {
    state.upgradedUserForceReviewWordList = payload
  },
  setNotLearnedYet (state, payload) {
    state.notLearnedYet = payload
  },
  setLearningCompleted (state, value) {
    state.learningCompleted = value
  }
}

const actions = {
  getGlossaries ({ commit }) {
    commit('setWaitForFetching', true)
    return new Promise((resolve, reject) => {
      axios.get(getGlossariesAPI).then((response) => {
        commit('setGlossaryList', response.data)
        commit('setWaitForFetching', false)
        resolve('OK')
      }).catch((err) => {
        reject(err)
      })
    })
  },
  getBooksByGlossary ({ commit }, payload) {
    commit('setWaitForFetching', true)
    return new Promise((resolve, reject) => {
      axios.post(getBooksByGlossaryAPI, {
        glossary_id: payload.glossary_id
      }).then((response) => {
        commit('setBookList', response.data)
        commit('setWaitForFetching', false)
        resolve('OK')
      }).catch((err) => {
        reject(err)
      })
    })
  },
  getLessonsByBook ({ commit }, payload) {
    commit('setWaitForFetching', true)
    return new Promise((resolve, reject) => {
      axios.post(getLessonsByBookAPI, {
        book_id: payload.book_id
      }).then((response) => {
        commit('setLessonList', response.data)
        commit('setWaitForFetching', false)
        resolve('OK')
      }).catch((err) => {
        reject(err)
      })
    })
  },

  getInitialSequenceAndBlockSize ({ commit, rootState, state }, payload) {
    commit('setWaitForFetching', true)
    let chosenGlossary = null
    let chosenBook = null
    let chosenLesson = null
    if (payload === null) {
      chosenGlossary = state.chosenGlossary
      chosenBook = state.chosenBook
      chosenLesson = state.chosenLesson
    } else {
      commit('setChosenGlossaryInfo', payload)
      chosenGlossary = payload.glossary
      chosenBook = payload.book
      chosenLesson = payload.lesson
    }
    return new Promise((resolve, reject) => {
      axios.post(getInitialSequenceAndBlockSizeAPI, {
        chosenGlossary: chosenGlossary,
        chosenBook: chosenBook,
        chosenLesson: chosenLesson,
        mode: rootState.vocabularyPractice.mode
      }).then((res) => {
        commit('setOtherFields', res.data.message)
        commit('setWaitForFetching', false)
        resolve()
      }).catch((err) => reject(err))
    })
  },

  checkIfForceReview ({ commit, rootState }, payload) {
    commit('setWaitForFetching', true)
    return new Promise((resolve, reject) => {
      axios.get(`${checkIfForceReviewAPI}?glossaryId=${payload.glossary_id}`)
        .then((res) => {
          // if (res.data.message === 'NOFORCEREVIEW') {
          //   resolve('NOFORCEREVIEW')
          // } else if (rootState.vocabularyPractice.isUpgraded) {
          //   console.log('returned:', res.data.message)
          //   commit('setUpgradedUserForceReviewWordList', res.data.message)
          //   commit('setWaitForFetching', false)
          //   resolve(res.data.message)
          // } else {
          //   commit('vocabularyPractice/setSelectedInitSeq', res.data.message.begin_from, { root: true })
          //   commit('vocabularyPractice/setSelectedBlockSize', res.data.message.block_size, { root: true })
          //   commit('setWaitForFetching', false)
          //   resolve(res.data.message)
          // }
          if (res.data.message.wordIdList === 'NOFORCEREVIEW' || res.data.message.wordIdList === 'COMPLETE') {
            resolve(res.data.message.wordIdList)
          } else {
            commit('setUpgradedUserForceReviewWordList', res.data.message.wordIdList)
            commit('setNotLearnedYet', res.data.message.notLearnedYet)
            commit('setWaitForFetching', false)
            resolve(res.data.message)
          }
        })
        .catch(err => reject(err))
    })
  },

  resetNotLearnedYet ({ commit }) {
    commit('setNotLearnedYet', '')
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
